import React, {useEffect, useState} from 'react';
import {Box, Button, Tooltip} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../Constants";
import {useLocation, useParams} from "react-router-dom";
import CustomerDetailsTable from "../../../components/UI/table/customer-detales/CustomerDetailsTable";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMyOrdersSectionPath,
    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";
import Typography from "@mui/material/Typography";
import UploadFilesRequestsForm from "../../organization/orders/estimate/UploadFilesRequestsForm";
import FileService from "../../../API/orders/orders/customer/FileService";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DetailControllerService from "../../../API/details/customer/DetailControllerService";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";

const imports = [
    {
        id: 1,
        helpText: "Импорт деталей из файла(базис раскроя)",
        multiple: true,
        upload: FileService.uploadRequestsCuttingFiles
    },
    {
        id: 2,
        helpText: "Импорт деталей из файла (базис раскроя) с использованием шаблонов",
        multiple: true,
        upload: FileService.uploadRequestsCuttingFilesWithSample
    },
    {
        id: 3,
        helpText: "Импорт деталей из файла (Pro100 раскроя)",
        multiple: false,
        upload: FileService.uploadRequestsCuttingFilesPro100
    },
    {
        id: 4,
        helpText: "Импорт деталей из файла (Pro100 раскроя) с использованием шаблонов",
        multiple: false,
        upload: FileService.uploadRequestsCuttingFilesPro100WithSample
    },
    {
        id: 5,
        helpText: "Импорт деталей из файлов КДТ",
        multiple: true,
        upload: FileService.uploadRequestsCuttingFilesKDT
    }
]
const CustomerRequestsCutting = () => {
    const pathname = useLocation().pathname
    const params = useParams();
    const {orderId, customerOrderNumber, requestsCuttingId, requestsCuttingNumber, year} = params

    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    const [alertData, setAlertData] = useState({}); //type 'error'| 'info' | 'success'| 'warning'

    const [data, setData] = useState([]);
    const [unable, setUnable] = useState({unableTurn: {}, unablePackage: {}});
    const [tab, setTab] = useState(1);

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };
    const [change, setChange] = useState(false);
    const [tableOptions, setTableOptions] = useState({pageIndex: 0, pageSize: 100, totalElements: 0, searchData: ""})

    const tableOptionsHandle = (nextState) => {
        if (nextState.pageSize !== tableOptions.pageSize) {
            setTableOptions(nextState)
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }

    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }

    useEffect(() => {
        setIsLoading(true)
        getStartPageSize()
        DetailControllerService.getAll(orderId, requestsCuttingId)
            .then(function (response) {
                const data = response?.data
                setData(data);
                setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
                setUnable(({unableTurn, unablePackage}) => {
                    data.forEach(row => {
                        unableTurn[row.id] = row.turn;
                        unablePackage[row.id] = row.package;
                    })
                    return {unableTurn, unablePackage}
                })
                setIsError(false)
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setIsLoading(false))
    }, [change]);

    return (
        isLoading ?
            <Box sx={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <CircularProgress disableShrink/>
            </Box> :
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={requestsCuttingNumber}
                    path={buildMyOrdersSectionPath(
                        CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
                        {
                            name: `${customerOrderNumber}`,
                            href: `/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/${year}`,
                        },
                    )}
                />
                <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                    <Box sx={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                            Детали
                        </Typography>
                    </Box>
                    <ModalAlert data={alertData} onClose={handleCloseAlert}/>
                    <ButtonGroupTabBar activeTab={tab}>
                        <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                            <CheckIcon/>
                            Детали
                        </Button>
                        <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                            <CheckIcon/>
                            Импорт
                        </Button>
                        {/*<Button tabIndex={3} onClick={(e) => handleChange(e, 3)}>*/}
                        {/*    <CheckIcon/>*/}
                        {/*    Экспорт*/}
                        {/*</Button>*/}
                    </ButtonGroupTabBar>
                    {tab === 1 ? <CustomerDetailsTable
                        data={data}
                        setChange={setChange}
                        unableTurn={unable.unableTurn}
                        unablePackage={unable.unablePackage}
                        pageSize={100}
                        isError={isError}
                        setData={setData}
                        enableEditing={true}
                        orderId={orderId}
                        year={year}
                        requestsCuttingId={requestsCuttingId}
                        customerOrderNumber={customerOrderNumber}
                        requestsCuttingNumber={requestsCuttingNumber}
                        tableOptionsHandle={tableOptionsHandle}
                        tableOptions={tableOptions}
                    /> : tab === 2 ? <Box>{imports.map(el => {
                        return <UploadFilesRequestsForm
                            key={el.id}
                            uploadData={el}
                            detail={true}
                            orderId={orderId}
                            change={change}
                            setChange={setChange}
                            calculationRequestsCutting={requestsCuttingId}
                            upload={el.upload}
                            multiple={el.multiple}
                            handleModalAlert={handleModalAlert}
                        />
                    })}
                    </Box> : <Box/>}
                </Box>
            </Box>
    )
}
export default CustomerRequestsCutting
